import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginRequest } from './login-request';
import { AdminService } from '../../service/admin.service';
import { UtilService } from '../../service/util.service';
import * as constants from '../../app.constants';
import { ErrorResponse } from '../../model/error-response';

declare let $: any;

@Component({
    selector: 'login',
    template: require('./login.component.html'),
    styles: [require('./login.component.css')]
})
export class LoginComponent implements OnInit, AfterViewInit {

  // private sha256 = require('js-sha256').sha256;
  public model: LoginRequest;
  public errorMsg: string;
  private returnUrl: string;

  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private adminService: AdminService) {
      this.model = new LoginRequest();
  }

  public ngOnInit(): void {
      this.returnUrl = this.route.snapshot.queryParams['next'] || '';
      if (localStorage.getItem('accessToken')) {
        this.router.navigate(['/manage/dashboard']);
      }
  }

  public ngAfterViewInit(): void {
      $('#username').focus();
  }

  public login(): void {
      console.log('Login form submitted.');
      console.log(this.model);
      this.errorMsg = null;
      if (!this.model.username || this.model.username.length < 1) {
          this.errorMsg = constants.messages.usernameRequired;
      } else if (!this.model.password || this.model.password.length < 1) {
          this.errorMsg = constants.messages.passwordRequired;
      } else {
          // this.model.password = sha256(this.model.password);// Convert password to sha256 digest
          this.adminService
              .postCall(constants.URLs.login, this.model, false)
              .then((res) => {
                  console.log('res');
                  console.log(res);
                  this.setLocalData(res);
                  if (this.returnUrl !== '') {
                    this.router.navigateByUrl(this.returnUrl);
                  } else {
                    // Default url
                    this.router.navigate(['/manage/dashboard']);
                  }
              })
              .catch((error: any) => {
                  try {
                    this.errorMsg = error.json().error_msg || constants.messages.serverError;
                    console.debug('LoginComponent- an error occurred', error);
                  } catch (e) {
                    this.errorMsg = error.message ? error.message : constants.messages.serverError;
                    console.error('LoginComponent- an error occurred', error);
                  }
              });
      }
  }

  protected setLocalData(data): void {
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem('accessToken', data.token);
    localStorage.setItem('userId', data.user_id);
    localStorage.setItem('email', data.email);
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/auth/login/login.component.ts